/**
 * Reads window.__SALON_BOOT__ — a tiny { name, logo } payload injected
 * server-side (see server-helpers.js injectMeta()) using the SAME salon
 * lookup that produces the WhatsApp/tab preview (og:title, og:image), just
 * exposed as a global instead of only rewriting meta tags. It's available
 * the instant the HTML is parsed — before the JS bundle loads, before
 * getSalonSpecificInfo/getSalonSpecificInfoByHost resolve — so loading
 * screens can show "Welcome to {name}" + the real logo immediately instead
 * of a generic spinner, with no flash-of-unbranded-content once the actual
 * salon data arrives from the API.
 *
 * Present only on routes the server resolved to a real business (a salon
 * slug page, or any page on a linked custom domain); absent on the Stylon
 * platform root, discovery pages, and unrecognized domains — never a
 * fallback/company brand.
 */
export function getSalonBoot() {
  if (typeof window === "undefined") return null;
  const boot = window.__SALON_BOOT__;
  if (!boot || !boot.name) return null;
  return { name: boot.name, logo: boot.logo || "" };
}
